import React, { useContext, useEffect, useRef, useState } from "react";

import { useClickOutside, diffData } from "../../../../utils";
import "./style.scss";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";

import { postByUrl, putByUrl } from "../../../../v3MethodsService";
import { confirmDialog } from "primereact/confirmdialog";
import { FileUpload } from "primereact/fileupload";
import { transliterate } from "transliteration";
import { ProgressSpinner } from "primereact/progressspinner";

const SideBar = ({ sideBarState, toast, docs, getDocs, visible, setVisible, data, setData, updateData, state, deleteHandler, removeAttachment, loader, setLoader }) => {
    const ref = useRef();
    const fileUploadRef = useRef();
    useClickOutside(visible, ref, () => setVisible(false));
    const dataToSend = diffData(sideBarState, data);

    const archivedHandler = () => {
        confirmDialog({
            message: "Деактивированные документы остаются в системе, но не отображаются для пользователей публичной части платформы",
            header: "Деактивировать документ?",
            icon: "pi pi-exclamation-triangle",
            acceptClassName: "p-button-danger",
            acceptLabel: "Деактивировать",
            rejectLabel: "Не деактивировать",
            draggable: false,
            style: { maxWidth: "582px" },
            accept: () => updateAttchement({ archived: true }, "Документ деактивирован"),
            reject: () => {},
        });
    };

    const unzipHandler = () => {
        confirmDialog({
            header: "Опубликовать документ?",
            acceptClassName: "p-button-danger",
            acceptLabel: "Опубликовать",
            rejectLabel: "Не опубликовывать",
            draggable: false,
            style: { maxWidth: "582px" },
            accept: () => updateAttchement({ archived: false }, "Документ опубликован"),
            reject: () => {},
        });
    };

    const handleSave = () => {
        if (data._id) {
            updateAttchement(dataToSend, "Документ обновлен", true);
        }
    };

    const onSelect = async (event) => {
        setLoader(true);
        const formData = new FormData();

        const originalFile = event.files[0];

        if (originalFile.size >= 5242880) {
            toast.show({ severity: "error", summary: "", detail: "Максимальный размер файла 5 МБ" });
            setLoader(false);
            fileUploadRef.current.clear();
            return;
        }

        const originalFileName = originalFile.name;
        const transliteratedFileName = transliterate(originalFileName);

        const renamedFile = new File([originalFile], transliteratedFileName, {
            type: originalFile.type,
            lastModified: originalFile.lastModified,
        });

        formData.append("file", renamedFile);
        formData.append("publicname", data.publicname);

        postByUrl("platformdocs", formData, true).then((resp) => {
            if (resp && resp.success) {
                getDocs();
                updateData(resp.data.file.data.filename, "filename");
                toast.show({ severity: "success", summary: "Документ добавлен", life: 1000 });
            } else {
                toast.show({ severity: "error", summary: resp?.message || "Ошибка сервера. Повторите попытку позже.", life: 1000 });
            }
            setLoader(false);
        });
    };

    const handleChangeFile = (event) => {
        setLoader(true);
        const formData = new FormData();

        const originalFile = event.files[0];

        if (originalFile.size >= 5242880) {
            toast.show({ severity: "error", summary: "", detail: "Максимальный размер файла 5 МБ" });
            setLoader(false);
            fileUploadRef.current.clear();
            return;
        }

        const originalFileName = originalFile.name;
        const transliteratedFileName = transliterate(originalFileName);

        const renamedFile = new File([originalFile], transliteratedFileName, {
            type: originalFile.type,
            lastModified: originalFile.lastModified,
        });

        formData.append("publicname", data.publicname);
        formData.append("file", renamedFile);

        postByUrl("platformdocs", formData, true).then((resp) => {
            if (resp && resp.success) {
                removeAttachment(data._id, false);
                toast.show({ severity: "success", summary: "Документ обновлен", life: 1000 });
            } else {
                toast.show({ severity: "error", summary: resp?.message || "Ошибка сервера. Повторите попытку позже.", life: 1000 });
            }
        });
    };

    const updateAttchement = (docData, toastName) => {
        putByUrl(`platformdocs/${data._id}`, docData).then((resp) => {
            if (resp && resp.success) {
                getDocs();
                toast.show({ severity: "success", summary: toastName, life: 1000 });
            } else {
                toast.show({ severity: "error", summary: resp?.message || "Ошибка сервера. Повторите попытку позже.", life: 1000 });
            }
        });
    };

    const disableButton = data && data.publicname && data.filename && dataToSend;

    return (
        !!visible &&
        !!data &&
        state && (
            <div className="side-profile__overlay p-sidebar-mask p-component-overlay p-component-overlay-enter p-sidebar-visible p-sidebar-right">
                <div className="side-profile p-component p-sidebar-enter-done" ref={ref}>
                    <div className="side-profile__header">
                        <div className="side-profile__btns">
                            <Button label="Сохранить" className="side-profile__button-save auth2__button" onClick={handleSave} disabled={!disableButton} />
                            {data.filename && data._id && (
                                <Button
                                    label={data.archived ? "Опубликовать" : "Деактивировать"}
                                    className="side-profile__button-save side-profile__button-delete auth2__button auth2__button_outlined"
                                    disabled={data.canonical}
                                    onClick={data.archived ? unzipHandler : archivedHandler}
                                />
                            )}
                            {data.filename && data._id && (
                                <Button
                                    label="Удалить"
                                    className="side-profile__button-save side-profile__button-delete auth2__button auth2__button_outlined"
                                    disabled={data.canonical}
                                    onClick={() => deleteHandler(data._id)}
                                />
                            )}
                        </div>
                        <i className="side-profile__icon-close pi pi-times" onClick={() => setVisible(false)} />
                    </div>
                    <div className="side-profile__body">
                        <span className="side-profile__title">{data._id ? "Редактировать документ" : "Загрузить документ"}</span>
                        <div className="clubs-profile__container border">
                            <label className="clubs-profile__label">
                                Отображаемое название* <span className="clubs-profile__label muted">(формат .doc, .docx, .txt, .pdf, размер файла до 5 мб)</span>
                            </label>
                            <InputText placeholder="Укажите название" value={data?.publicname || ""} onChange={(e) => updateData(e.target.value, "publicname")} />
                        </div>

                        {!data.filename && !loader ? (
                            <FileUpload
                                ref={fileUploadRef}
                                disabled={!data.publicname}
                                mode="basic"
                                customUpload
                                accept=".doc,.docx,.txt,.pdf"
                                className="load-data-item__fileupload load-data-item__fileupload_button"
                                chooseLabel="Загрузить файл"
                                chooseOptions={{ icon: "pi pi-upload" }}
                                onSelect={data._id ? handleChangeFile : onSelect}
                            />
                        ) : loader ? (
                            <ProgressSpinner style={{ width: "40px", height: "40px" }} strokeWidth="4" fill="var(--surface-ground)" animationDuration=".5s" className="loader" />
                        ) : (
                            <div className="side-profile__file">
                                <span className="side-profile__file-name">{data.filename.split(".")[0]}</span>
                                <span className="side-profile__file-format">{data.filename.split(".").at(-1).toUpperCase()}</span>
                                <div className="side-profile__buttons">
                                    <FileUpload
                                        ref={fileUploadRef}
                                        disabled={!data.publicname}
                                        mode="basic"
                                        customUpload
                                        accept=".pdf"
                                        className="load-data-item__fileupload load-data-item__fileupload_button load-data-item__refresh"
                                        chooseOptions={{ icon: "pi pi-refresh" }}
                                        onSelect={handleChangeFile}
                                    />
                                    <Button icon="pi pi-trash" className="p-button-outlined p-button-danger" onClick={() => updateData(null, "filename")} />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    );
};

export default SideBar;
